module.exports = "<navbar></navbar>\n<h1>{{ $ctrl.name }}</h1>\n<section>\n  About us.\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/about/about.html
// module id = 569
// module chunks = 0